import { render, staticRenderFns } from "./viewShipmentInspection.vue?vue&type=template&id=4fea9bee&scoped=true"
import script from "./viewShipmentInspection.vue?vue&type=script&lang=js"
export * from "./viewShipmentInspection.vue?vue&type=script&lang=js"
import style0 from "./viewShipmentInspection.vue?vue&type=style&index=0&id=4fea9bee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea9bee",
  null
  
)

export default component.exports